import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from "moment";

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class LeaseDetailsDocuments extends Component {
    static displayName = LeaseDetailsDocuments.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id');

        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            documentFiles: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            leaseId: id,
            typeOptions: [{ label: "Lease", value: "Lease" },
            { label: "Lease Amendment", value: "Lease Amendment" },
            { label: "Estoppel", value: "Estoppel" },
            { label: "Certificate of Insurance", value: "Certificate of Insurance" },
            { label: "SNDA", value: "SNDA" },
            { label: "Space Plan", value: "Space Plan" },
            { label: "Site Plan", value: "Site Plan" },
            { label: "Site Photos", value: "Site Photos" },
            { label: "Other", value: "Other" }],
            tn_editMode: false,
            term_notes: {},
            lease: {}, //For header
            mimeTypes: {
                'txt': 'text/plain',
                'pdf': 'application/pdf',
                'doc': 'application/msword',
                'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'xls': 'application/vnd.ms-excel',
                'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'png': 'image/png',
                'gif': 'image/gif',
                'svg': 'image/svg+xml',
                'mp3': 'audio/mpeg',
                'mp4': 'video/mp4',
                'html': 'text/html',
                'css': 'text/css',
                'js': 'application/javascript',
                'json': 'application/json'
            },
            currentItems: []
        };
        this.checkAuthenticated();
        this.GetLease(); //For header
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isWrite = await AdminFunctions.isRole("Write");
        }
        this.setState({ isAdmin: isAdmin || isWrite });
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //this.ShowAllLeases();
        this.GetDocumentFiles();
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ documentFiles: data });
    }

    onFileChange = (event, i) => {
        // Update the state 
        if (event) {
            if (event.target) {
                if (event.target.files[0]) {
                    var documentFilesTemp = this.state.documentFiles;
                    documentFilesTemp[i].downloadedFile = event.target.files[0];
                    this.setState({ documentFiles: documentFilesTemp });
                }
            }
        } else {
            var documentFilesTemp = this.state.documentFiles;
            documentFilesTemp[i].downloadedFile = {};
            this.setState({ documentFiles: documentFilesTemp });
        }

        //this.setState({ selectedFile: event.target.files[0] });
    };

    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.documentFiles.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.documentFiles.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.documentFiles.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.documentFiles;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            documentFiles: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.documentFiles;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            documentFiles: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {

        // Logic for displaying documentFiles
        const currentItems = this.state.documentFiles;

        const renderItems = currentItems.map((candidate, i) => {
            return (
                <tr key={i} className={new Date(candidate.rt_start) < new Date() && new Date(candidate.rt_end) > new Date() ? 'highlightRow' : ''} >
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {candidate.type}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <select
                                    options={this.state.typeOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var documentFilesTemp = this.state.documentFiles;
                                        documentFilesTemp[i].type = e.target.value;
                                        this.setState({ documentFiles: documentFilesTemp });
                                    }}
                                    value={candidate.type}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.typeOptions.map(option => {
                                        return (
                                            <option key={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                <label className="textAsLink" onClick={(e) => { this.GetFile(candidate.file_id, candidate.name) }}>{candidate.name}</label>
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <>
                                <div>
                                    <label className="textLabel">Document Name:</label> <br />
                                    <input
                                        type="text"
                                        value={candidate.name}
                                        onChange={(e) => {
                                            var documentFilesTemp = this.state.documentFiles;
                                            documentFilesTemp[i].name = e.target.value;
                                            this.setState({ documentFiles: documentFilesTemp });
                                        }}
                                        name="name"
                                        id='name'
                                        style={{ 'width': '200px' }}
                                    />
                                </div>
                                <div>
                                    <label className="textLabel">Upload new file:</label> <br />
                                    <input type="file" onChange={(e) => {
                                        this.onFileChange(e, i);
                                    }}
                                    />
                                </div>
                            </>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {candidate.text}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <textarea
                                    type="textarea"
                                    value={candidate.text}
                                    onChange={(e) => {
                                        var documentFilesTemp = this.state.documentFiles;
                                        documentFilesTemp[i].text = e.target.value;
                                        this.setState({ documentFiles: documentFilesTemp });
                                    }}
                                    name="text"
                                    id='text'
                                    style={{ 'height': '137px', 'width': '100%' }}
                                />
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>

                                <Button
                                    color='primary'
                                    onClick={() => {
                                        var documentFilesTemp = this.state.documentFiles;
                                        documentFilesTemp[i].prevTerms = Object.assign({}, documentFilesTemp[i]);
                                        documentFilesTemp[i].editMode = true;
                                        this.setState({ documentFiles: documentFilesTemp });
                                    }}
                                    className="g-orange-bg g-orange-c g-orange-button gButton"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                    disabled={this.state.loading === true ? true : false}
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    Edit
                                </Button>
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var documentFilesTemp = this.state.documentFiles;
                                    if (this.IsEmpty(candidate) === true) {
                                        this.DeleteEmpty(i);
                                    }
                                    else {
                                        //this.setState({ documentFiles: documentFilesTemp });
                                        this.SaveDocumentFiles(candidate, i);
                                    }

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                {this.IsEmpty(candidate) === false ? 'Save' : 'Delete'}
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.file_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var documentFilesTemp = this.state.documentFiles;
                                    documentFilesTemp[i] = documentFilesTemp[i].prevTerms;
                                    documentFilesTemp[i].prevTerms = {};
                                    documentFilesTemp[i].editMode = false;
                                    this.setState({ documentFiles: documentFilesTemp });

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Cancel
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.file_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    this.DeleteExisting(candidate, i);
                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Delete
                            </Button>
                        )}
                    </td>
                </tr>
            )
        });

        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Lease Details</h3>
                </div>
                <div id="body" className="g-warm-gray-c">
                    <Row>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>
                            <label className="g-almost-black-c addressTitle">
                                {this.state.lease.sd_address}<br />
                                {this.state.lease.sd_city}, {this.state.lease.sd_state} {this.state.lease.sd_zip}
                            </label> {/*//For header*/}
                        </Col>
                    </Row>
                    <Row className="g-warm-gray-bg g-warm-gray-c" style={{ 'textAlign': 'center' }}>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Summary?id=' + this.state.leaseId}
                            >
                                Summary
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-RentTerms?id=' + this.state.leaseId}
                            >
                                Rent Terms
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-CriticalDates?id=' + this.state.leaseId}
                            >
                                Critical Dates
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Notes?id=' + this.state.leaseId}
                            >
                                Notes
                            </NavLink>
                        </Col>
                        <Col className="g-orange-bg g-orange-c">
                            Documents
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Contacts?id=' + this.state.leaseId}
                            >
                                Contacts
                            </NavLink>
                        </Col>
                    </Row>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing noBottomBorder">
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '100px' }}>
                                            Type
                                            <FaSort
                                                color={this.state.sort.column === 'rt_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('rt_type')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            Document
                                            <FaSort
                                                color={this.state.sort.column === 'rt_start' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('rt_start')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            Note
                                            <FaSort
                                                color={this.state.sort.column === 'rt_end' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('rt_end')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c buttonColumn" style={{ 'width': '106px' }}>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="rightAlignButtons">
                                                            <Button
                                                                color='primary'
                                                                onClick={() => {
                                                                    this.AddRows(1);
                                                                }}
                                                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                    hidden={!this.state.isAdmin ? true : false}
                                                            >
                                                                Add
                                                                </Button>
                                                                <Link
                                                                    to="/Lease/ActiveLeases?search=1"
                                                                    color='primary'
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton btn btn-primary"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", padding: '5px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                >
                                                                    Back To List
                                                                </Link>
                                                        </td>
                                                    </tr>

                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    async GetDocumentFiles() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetDocumentFiles?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
        const data = await response.json();
        this.setState({ documentFiles: data });
    }
    AddRows(number) {
        for (var i = 0; i < number; i++) {
            var newRow = { file_id: 0, site_id: this.state.leaseId, type: null, filename: '', name: '', text: '', date: null, user_id: 0, active: true, editMode: true };
            var documentFilesTemp = this.state.documentFiles;
            documentFilesTemp.push(newRow);
            this.setState({ documentFiles: documentFilesTemp });
        }
    }
    IsEmpty(candidate) {
        if (candidate.type || candidate.name || candidate.text) {
            //If anything is filled out, it's not empty.
            return false;
        }
        if (candidate.file_id) {
            //If it's not a new item, it's not considered empty for this.
            return false;
        }
        return true;
    }
    //async SaveDocumentFiles(documentFile, index) {
    //    const token = Session.getToken();
    //    const response = await fetch('api/Leases/EditDocumentFiles', {
    //        method: 'POST',
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    //        body: JSON.stringify(documentFile)
    //    })
    //}

    async SaveDocumentFiles(documentFile, index) {
        this.setState({ loading: true });
        const formData = new FormData();

        if (documentFile.file_id === 0) {
            documentFile.date = new Date().toISOString();
        }
        formData.append("file_id", documentFile.file_id);
        formData.append("site_id", documentFile.site_id);
        formData.append("type", documentFile.type);
        formData.append("filename", documentFile.filename);
        formData.append("name", documentFile.name);
        formData.append("text", documentFile.text);
        formData.append("date", documentFile.date);
        formData.append("user_id", documentFile.user_id);
        formData.append("active", documentFile.active);
        formData.append("editMode", documentFile.editMode);
        formData.append("documentBase64", documentFile.documentBase64);
        formData.append("downloadedFile", documentFile.downloadedFile);

        // Details of the uploaded file 
        console.log(formData);

        // Request made to the backend api
        // Send formData object
        const token = Session.getToken();
        const response = await fetch('api/Leases/EditDocumentFiles', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            body: formData
        })
        //                                        documentFilesTemp[i].editMode = false;
        const data = await response.json();
        if (data) {
            if (data.file_id > 0) {
                var documentFilesTemp = this.state.documentFiles;
                documentFilesTemp[index].editMode = false;
                documentFilesTemp[index].file_id = data.file_id;
                this.setState({ documentFiles: documentFilesTemp });
            }
        }


        this.setState({ loading: false });
    }

    DeleteEmpty(index) {
        var documentFilesTemp = this.state.documentFiles;
        documentFilesTemp.splice(index, 1);
        this.setState({ documentFiles: documentFilesTemp });
    }

    async DeleteExisting(candidate, index) {
        if (window.confirm("Are you sure you want to delete this Document File?") === true) {
            const token = Session.getToken();
            const response = await fetch('api/Leases/DeleteDocumentFiles?id=' + candidate.file_id, {
                method: 'GET',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            })

            var documentFilesTemp = this.state.documentFiles;
            documentFilesTemp.splice(index, 1);
            this.setState({ documentFiles: documentFilesTemp });
        }
    }

    async SaveAll(candidate, index) {
        var documentFilesTemp = this.state.documentFiles;
        for (let i = 0; i < documentFilesTemp.length; i++) {

        }
    }
    downloadFile(file, name) {
        const blob = this.base64ToBlob(file, name);
        const uriContent = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', uriContent);
        link.setAttribute('download', name);
        const event = new MouseEvent('click');
        link.dispatchEvent(event);
    }

    base64ToBlob = (file, name) => {
        const binaryString = window.atob(file);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; ++i) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: this.getContentType(name) });
        return blob;
    }

    getContentType(filename) {
        const extension = filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
        return this.state.mimeTypes[extension] || 'application/octet-stream';
    }

    async GetFile(file_id, name) {
        //event.target.attributes['value'].value
        //alert("Downloading " + file_id);
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetDocument?file_id=' + file_id, {
            method: 'GET',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        })
        const data = await response.json();
        //var fileBase64 = data.documentBase64;
        this.downloadFile(data.documentBase64, data.filename);
    }

    async IsValid(index) {
        //checks if the current item at index is valid!
        var item = this.state.this.state.documentFiles[index];
        var error = "";
        //Verify!
        if (!item.type) {
            error = "Type is required.";
            return error;
        }
        if (!item.name) {
            error = "Document Name is required.";
            return error;
        }
        if (!item.downloadedFile && item.file_id === 0) {
            error = "Document File is required.";
            return error;
        }
        if (!item.text) {
            error = "Notes is required.";
            return error;
        }
    }
    //For header
    async GetLease() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetLease?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },

        })
        const data = await response.json();
        this.setState({ lease: data });
    }
}

